var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"referral-reminder"},[_vm._v(" 如出现持续高热、呼吸困难、指氧饱和度<93%等情况请尽快转诊。 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }